
export class AudioAssets {
  static CardMoved = 'assets/audio/card-moved.wav';
  static NextTurn = 'assets/audio/next-turn.wav';
  static LastTurn = 'assets/audio/last-turn.wav';
  static NextRound = 'assets/audio/next-round.wav';
}
